import crud from './_crud'
import { callApi } from 'utils/api'
const actions = crud(
	'incident_subcategory',
	'la subcategoria de incidencia',
	'las subcategorias de incidencias'
)

const loadCategories = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/category_form/load_categories`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: options,
		})

		return res.body
	}
}
const getFormattedCategories = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/incident_subcategory/utils/formatted_incident_categories_list`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			params: options,
		})

		return res.body
	}
}

const createSubcategories = (item, options = {}) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/incident_subcategory/incident_subcategories`, {
			method: 'POST',
			body: JSON.stringify(item),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: options?.showMessage === false ? undefined : `Se agregó el cliente correctamente.`,
		})
	}
}

const get_incident_subcategories = (item, history) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/incident_subcategory/utils/get_incident_subcategories`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
				params: {
					incident_category_id: item,
					sys_company_id: state.app.user.sys_company_id,
				},
			}
		)

		dispatch({
			type: `LOAD_INCIDENT_SUBCATEGORY`,
			payload: res.body,
		})
	}
}
export default {
	...actions,
	loadCategories,
	getFormattedCategories,
	createSubcategories,
	get_incident_subcategories,
}
